<template>
  <b-navbar type="is-dark">
    <template #brand>
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          FermiCloud
        </b-navbar-item>
    </template>
    <template #end>
      <b-navbar-item disabled :label="keycloak.idTokenParsed.preferred_username">
        {{ keycloak.idTokenParsed.preferred_username }}
      </b-navbar-item>
      <b-navbar-item tag="div">
        <div class="buttons" @click="keycloak.logout()">
          <a class="button is-light">
            <strong>{{ $t('global.logout') }}</strong>
          </a>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>

  <div id="app" class="main-layout">
    <div class="columns">
      <div class="column is-1">
        <nav class="menu">
          <p class="menu-label">
          </p>
          <div class="is-flex justify-content-center is-justify-content-space-around">
            <ul class="menu-list">
              <router-link to="/dashboard" :title="$t('global.dashboard')">
                <figure class="image is-48x48">
                  <img src="@/assets/icons/dashboard.png" alt="dashboard" :title="$t('global.dashboard')">
                </figure>
                <!-- <font-awesome-icon icon="tachometer-alt" class="fa-2x" size="is-large"></font-awesome-icon> -->
                <!-- <b-icon icon="view-dashboard-outline" size="is-large"></b-icon> -->
                <!-- <b-icon icon="gauge" size="is-large"></b-icon> -->
              </router-link>
              <router-link to="/projects" :title="$t('global.projects')">
                <font-awesome-icon icon="code" class="fa-2x" size="is-large"></font-awesome-icon>
              </router-link>
              <router-link to="/devices" :title="$t('global.devices')">
                <figure class="image is-48x48">
                  <img src="@/assets/icons/device.png" alt="devices" :title="$t('global.devices')">
                </figure>
                <!-- <font-awesome-icon icon="microchip" class="fa-2x" size="is-large"></font-awesome-icon> -->
                <!-- <b-icon icon="memory" size="is-large"></b-icon> -->
                <!-- <b-icon icon="devices" size="is-large"></b-icon> -->
              </router-link>
              <router-link to="/events" :title="$t('global.events')">
                <figure class="image is-48x48">
                  <img src="@/assets/icons/log.png" alt="events" :title="$t('global.events')">
                </figure>
                <!-- <font-awesome-icon icon="list" class="fa-2x" size="is-large"></font-awesome-icon> -->
                <!-- <b-icon icon="list-box-outline" size="is-large"></b-icon> -->
              </router-link>
              <router-link to="/integrations" :title="$t('global.integrations')">
                <font-awesome-icon icon="puzzle-piece" class="fa-2x" size="is-large"></font-awesome-icon>
                <!-- <b-icon icon="webhook" size="is-large"></b-icon> -->
              </router-link>
              <router-link to="/secrets" :title="$t('global.secrets')">
                <font-awesome-icon icon="key" class="fa-2x" size="is-large"></font-awesome-icon>
                <!-- <b-icon icon="lock" size="is-large"></b-icon> -->
              </router-link>
              <router-link to="/settings" :title="$t('global.settings')">
                <figure class="image is-48x48">
                  <img src="@/assets/icons/gear.png" alt="integrations" :title="$t('global.integrations')">
                </figure>
                <!-- <font-awesome-icon icon="user-gear" class="fa-2x" size="is-large"></font-awesome-icon> -->
                <!-- <b-icon icon="cog" size="is-large"></b-icon> -->
              </router-link>
            </ul>
          </div>
        </nav>
      </div>
      <div class="column">
        <div class="section">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'vuex'

export default {
  name: 'App',
  inject: ['keycloak'],
  computed: {
    ...mapState(['user']),
  },
  watch: {
    ['user.language']: {
      immediate: true,
      handler(newValue) {
        this.$i18n.locale = newValue || 'en';
      }
    },
  },
};
</script>

<style scoped>

#app {
  margin: var(--app-margin);
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  margin: 0.25rem 0;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-list li {
  margin: 0;
}

.menu-list a {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  margin: 0.25rem;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  text-decoration: none;
}

.menu-list a:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.menu-list a.router-link-active {
  background-color: rgba(255, 255, 255, 0.2);
}

/* Mobile: make the sidebar nav horizontal with minimal overrides */
@media screen and (max-width: 768px) {
  .menu-list {
    display: flex;
  }
}

</style>
